import type { Pinia } from 'pinia';
import { appStore } from 'src/stores/appStore';
import { useAuthStore } from 'src/stores/authStore';
import KeycloakService from 'src/security/KeycloakService';

const stripKeycloakErrorHash = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const { hash, pathname, search } = window.location;
  if (!hash) {
    return;
  }

  const loweredHash = hash.toLowerCase();
  const hasKeycloakError =
    loweredHash.includes('error=') && loweredHash.includes('state=');

  if (hasKeycloakError) {
    window.history.replaceState(null, '', `${pathname}${search}`);
  }
};

export default async function initAuth(pinia: Pinia) {
  const authStore = useAuthStore(pinia);
  console.info('[Boot] Starting auth initialization');
  try {
    const authenticated = await authStore.initialize();
    console.info('[Boot] Auth initialization complete', {
      authenticated,
      isAuthDisabled: authStore.DEV_AUTH_MOCK_ENABLED
        ? 'dev-mock'
        : authStore.isAuthenticated,
      keycloakDisabled: KeycloakService?.isAuthDisabled,
      keycloakReason: KeycloakService?.disableReason,
    });
  } catch (error) {
    console.error('[Boot] Failed to initialize auth store', error);
  }
  stripKeycloakErrorHash();
  console.info('[Boot] Triggering app initialization');
  const app = appStore(pinia);
  Promise.resolve()
    .then(() => app.initialize())
    .then((result) => {
      console.info('[Boot] App store initialize resolved', {
        result,
        initialized: app.initialized,
        sections: app.sectionData?.length,
      });
    })
    .catch((error) => {
      console.error('[Boot] Failed to initialize app store', error);
    })
    .finally(() => {
      console.info('[Boot] App initialization promise finished');
    });
}
